<template>
	<div class="patients">
		<div style="position: sticky; top:12px; z-index: 200;">
			<Breadcrumbs :items="items" />
		</div>
		<v-container fluid>
			<v-btn
				v-if="$store.getters.hasRole('terapeut')"
				class="mt-2"
				text
				small
				color="primary"
				@click="showStatistics"
				:loading="loadingStatistics"
			>
				<translate>Statistics</translate>
				<v-icon v-if="!showPatientStatistics" color="primary">mdi-chevron-down</v-icon>
				<v-icon v-else color="primary">mdi-chevron-up</v-icon>
			</v-btn>
			<PatientStatistics
				v-if="showPatientStatistics"
				:nPatients="nPatients"
				:nAppointments="nAppointments"
				:average="average"
				:genderPercentages="genderPercentages"
				:ageInfo="ageInfo"
			/>
			<v-text-field
				v-model="search"
				prepend-inner-icon="search"
				:placeholder="$gettext('Search Patient...')"
				single-line
				outlined
				solo
				class="mt-5 mb-3"
				hide-details
			></v-text-field>
			<!-- <v-pagination v-model="page" :length="26" circle></v-pagination> -->
			<AlphabeticFilter :value="letter" ref="alphabeticFilter" />
			<!-- <v-btn v-if="$store.getters.canCreatePatient" small fab class="mb-3" color="primary" :to="{name: 'new-patient'}" :disabled="!$store.getters.hasAnyModule">
				<v-icon>mdi-plus</v-icon>
			</v-btn> -->
			<v-btn
				v-if="$store.getters.canCreatePatient"
				small
				color="primary"
				:disabled="!$store.getters.hasAnyModule"
				class="my-1 mr-1"
				:to="{name: 'new-patient'}"
			>
				<v-icon small class="mr-1">add</v-icon>
				<translate>New Patient</translate>
			</v-btn>
			<v-data-table
				disable-sort
				disable-pagination
				fixed-header
				item-key="id"
				:headers="headers"
				:items="filteredPatients"
				:search="search"
				hide-default-footer
				:no-data-text="$gettext('No Patients found')"
			>
				<template v-slot:item="{item}">
					<tr v-if="$store.getters.tourMode && item.name == 'Alberto Caeiro'" @click="clickPatient(item.id)" :style="$store.getters.tourMode ? {'position': 'relative', 'z-index': 400, 'background': '#FFFFFF'} : ''">
						<td>{{item.name}}</td>
						<td>{{item.email}}</td>
						<td>{{item.phone}}</td>
						<td>{{item.fiscal}}</td>
					</tr>
					<tr v-else @click="clickPatient(item.id)" style="cursor: pointer">
						<td>{{item.name}}</td>
						<td>{{item.email}}</td>
						<td>{{item.phone}}</td>
						<td>{{item.fiscal}}</td>
					</tr>
				</template>
			</v-data-table>
		</v-container>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PatientStatistics from "@/components/patient/PatientStatistics.vue";
import AlphabeticFilter from "@/components/AlphabeticFilter.vue";
import axios from "axios";
import { mapGetters } from 'vuex'

export default {
	name: "patients",
	components: {
		Breadcrumbs,
		PatientStatistics,
		AlphabeticFilter
	},
	methods: {
		clickPatient(patientId) {
			this.$router.push({ name: "patient", params: { pid: patientId } });
		},
		showStatistics() {
			if(!this.showPatientStatistics){
				this.loadingStatistics = true;
				axios
					.get("/patients/statistics")
					.then(response => {
						console.log(response.data);
						if (response.status === 200) {
							this.nPatients = response.data.num_patients;
							this.nAppointments = response.data.num_appointments;
							this.average = response.data.average;
							this.genderPercentages = response.data.gender_percentages;
							this.ageInfo = response.data.age_info;
							this.loadingStatistics = false;
							this.showPatientStatistics = true;
						}
					})
					.catch(error => {console.log(error); this.loadingStatistics = false});
			} else {
				this.showPatientStatistics = false;
			}
		}
	},
	data: () => ({
		nPatients: 0,
		nAppointments: 0,
		average: 0,
		genderPercentages: {
			male: 0,
			female: 0
		},
		ageInfo: {
			age_1: 0,
			age_2: 0,
			age_3: 0,
			age_4: 0
		},
		search: "",
		patients: [],
		page: 1,
		letter: "no-filter",
		isMounted: false,
		showPatientStatistics: false,
		loadingStatistics: false
	}),
	computed: {
		filteredPatients() {
			if (!this.isMounted) {
				return [];
			} else if (this.$refs.alphabeticFilter.getLetter() === "no-filter") {
				return this.patients;
			} else {
				return this.patients.filter(p => {
					return (
						p.name.charAt(0).toUpperCase() ===
						this.$refs.alphabeticFilter.getLetter().toUpperCase()
					);
				});
			}
		},
		items() {
			return [
				{
					text: this.$gettext("Patients"),
					disabled: false,
					link: true,
					to: { name: "patients" }
				}
			];
		},
		headers() {
			return [
				{
					text: this.$gettext("Name"),
					align: "left",
					value: "name"
				},
				{ text: this.$gettext("Email"), value: "email" },
				{ text: this.$gettext("Phone"), value: "phone" },
				{ text: this.$gettext("VAT Number"), value: "nif" }
			];
		},
		...mapGetters({
      tourStep: 'tourStepEvent'
    })
	},
	mounted() {
		this.isMounted = true;
	},
	created() {
		axios
			.get("/patients")
			.then(response => {
				console.log(response.data);
				if (response.status === 200) {
					this.patients = response.data.patients;
				}
			})
			.catch(error => console.log(error));
	},
	watch: {
		tourStep(value) {
			if(value == 'tour-select-patient') {
				let i = 0;
				for(;i<this.patients.length; i++) {
					if(this.patients[i].name == 'Alberto Caeiro') break;
				}
				this.clickPatient(this.patients[i].id);
			}
		}
	}
};
</script>

<style scoped>
.focused {
	cursor: pointer;
	position: relative;
	z-index: 400;
	background: '#eeeeee';
}
</style>